module.exports = __webpack_public_path__ + "img/eggplant-caviar.e0139dce.jpg";